import { createReducer } from 'typesafe-actions'
import {
  createFollowupHandle,
  updateFollowupHandle,
  deleteFollowupHandle,
  fetchFollowupsByOperatorHandle
} from './handles'
import { FollowupState, FollowupAction } from './types'

export const initialState: FollowupState = {
  followups: [],
  total: 0,
  page: 1,
  totalPages: 1,
  isLoadingFetchFollowups: false,
  isSuccessOnFetchFollowups: false,
  isErrorOnFetchFollowups: false,
  isLoadingCreateFollowup: false,
  isSuccessOnCreateFollowup: false,
  isErrorOnCreateFollowup: false,
  isLoadingUpdateFollowup: false,
  isSuccessOnUpdateFollowup: false,
  isErrorOnUpdateFollowup: false,
  isLoadingDeleteFollowup: false,
  isSuccessOnDeleteFollowup: false,
  isErrorOnDeleteFollowup: false
}

export const followupReducer = createReducer<FollowupState, FollowupAction>(initialState)
  .handleAction(fetchFollowupsByOperatorHandle.asyncAction.request, fetchFollowupsByOperatorHandle.request)
  .handleAction(fetchFollowupsByOperatorHandle.asyncAction.success, fetchFollowupsByOperatorHandle.success)
  .handleAction(fetchFollowupsByOperatorHandle.asyncAction.failure, fetchFollowupsByOperatorHandle.failure)
  .handleAction(createFollowupHandle.asyncAction.request, createFollowupHandle.request)
  .handleAction(createFollowupHandle.asyncAction.success, createFollowupHandle.success)
  .handleAction(createFollowupHandle.asyncAction.failure, createFollowupHandle.failure)
  .handleAction(updateFollowupHandle.asyncAction.request, updateFollowupHandle.request)
  .handleAction(updateFollowupHandle.asyncAction.success, updateFollowupHandle.success)
  .handleAction(updateFollowupHandle.asyncAction.failure, updateFollowupHandle.failure)
  .handleAction(deleteFollowupHandle.asyncAction.request, deleteFollowupHandle.request)
  .handleAction(deleteFollowupHandle.asyncAction.success, deleteFollowupHandle.success)
  .handleAction(deleteFollowupHandle.asyncAction.failure, deleteFollowupHandle.failure)
